// Country currencies, separate from the existing USD shipping schedule.
const groups = {
  USD: 'US EC SV MH FM PW TL', EUR: 'AD AT BE BG HR CY EE FI FR DE GR IE IT LV LT LU MT MC ME NL PT SM SK SI ES',
  XAF: 'CM CF TD CG GQ GA', XOF: 'BJ BF CI GW ML NE SN TG', XCD: 'AG DM GD KN LC VC',
  AUD: 'AU KI NR TV', CHF: 'CH LI', NZD: 'NZ', GBP: 'GB',
  AFN: 'AF', ALL: 'AL', DZD: 'DZ', AOA: 'AO', ARS: 'AR', AMD: 'AM', AZN: 'AZ',
  BSD: 'BS', BHD: 'BH', BDT: 'BD', BBD: 'BB', BYN: 'BY', BZD: 'BZ', BTN: 'BT',
  BOB: 'BO', BAM: 'BA', BWP: 'BW', BRL: 'BR', BND: 'BN', BIF: 'BI', CVE: 'CV',
  KHR: 'KH', CAD: 'CA', CLP: 'CL', CNY: 'CN', COP: 'CO', KMF: 'KM', CDF: 'CD',
  CRC: 'CR', CUP: 'CU', CZK: 'CZ', DKK: 'DK', DJF: 'DJ', DOP: 'DO', EGP: 'EG',
  ERN: 'ER', SZL: 'SZ', ETB: 'ET', FJD: 'FJ', GMD: 'GM', GEL: 'GE', GHS: 'GH',
  GTQ: 'GT', GNF: 'GN', GYD: 'GY', HTG: 'HT', HNL: 'HN', HUF: 'HU', ISK: 'IS',
  INR: 'IN', IDR: 'ID', IRR: 'IR', IQD: 'IQ', ILS: 'IL', JMD: 'JM', JPY: 'JP',
  JOD: 'JO', KZT: 'KZ', KES: 'KE', KWD: 'KW', KGS: 'KG', LAK: 'LA', LBP: 'LB',
  LSL: 'LS', LRD: 'LR', LYD: 'LY', MGA: 'MG', MWK: 'MW', MYR: 'MY', MVR: 'MV',
  MRU: 'MR', MUR: 'MU', MXN: 'MX', MDL: 'MD', MNT: 'MN', MAD: 'MA', MZN: 'MZ',
  MMK: 'MM', NAD: 'NA', NPR: 'NP', NIO: 'NI', NGN: 'NG', MKD: 'MK', NOK: 'NO',
  OMR: 'OM', PKR: 'PK', PAB: 'PA', PGK: 'PG', PYG: 'PY', PEN: 'PE', PHP: 'PH',
  PLN: 'PL', QAR: 'QA', RON: 'RO', RUB: 'RU', RWF: 'RW', WST: 'WS', STN: 'ST',
  SAR: 'SA', RSD: 'RS', SCR: 'SC', SLE: 'SL', SGD: 'SG', SBD: 'SB', SOS: 'SO',
  ZAR: 'ZA', SSP: 'SS', LKR: 'LK', SDG: 'SD', SRD: 'SR', SEK: 'SE', SYP: 'SY',
  TWD: 'TW', TJS: 'TJ', TZS: 'TZ', THB: 'TH', TOP: 'TO', TTD: 'TT', TND: 'TN',
  TRY: 'TR', TMT: 'TM', UGX: 'UG', UAH: 'UA', AED: 'AE', UYU: 'UY', UZS: 'UZ',
  VUV: 'VU', VES: 'VE', VND: 'VN', YER: 'YE', ZMW: 'ZM', ZWG: 'ZW',
};

export const COUNTRY_CURRENCIES = Object.fromEntries(
  Object.entries(groups).flatMap(([currency, codes]) => codes.split(' ').map(code => [code, currency]))
);

// BRL, CNY and MYR require in-country merchant accounts. The existing
// USD checkout is not configured for those local merchant restrictions.
export const PAYPAL_CURRENCIES = new Set([
  'USD', 'AUD', 'CAD', 'CZK', 'DKK', 'EUR', 'HKD', 'HUF', 'ILS', 'JPY',
  'MXN', 'TWD', 'NZD', 'NOK', 'PHP', 'PLN', 'GBP', 'SGD', 'SEK', 'CHF', 'THB',
]);

export function countryCurrency(code) {
  const currency = COUNTRY_CURRENCIES[code];
  if (!currency) throw new Error(`No currency configured for country ${code}`);
  return currency;
}

export function paypalCurrency(currency) {
  return PAYPAL_CURRENCIES.has(currency) ? currency : 'USD';
}
